import type { SVGProps } from 'react';
const DawnFlagNZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-NZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-NZ_svg__a)">
      <path fill="#0A17A7" d="M0 0h22v16H0z" />
      <path
        fill="#FF2E3B"
        fillRule="evenodd"
        d="M3.667 3.2 0 0h.524L4.19 2.667h1.048L9.428 0v.364a.33.33 0 0 1-.137.27L5.761 3.2v1.067L9.078 7.16a.175.175 0 0 1-.115.307"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3.667 3.2v1.067L0 6.933v.534L4.19 4.8H5.24l3.62 2.633a.175.175 0 0 0 .218-.273L5.762 4.267V3.2L9.292.633a.33.33 0 0 0 .137-.27V0l-4.19 2.667H4.19L.524 0H0zm.74-1.2L.742-.667h-2.518L3 3.503v.424L-.666 6.594V8.68l5.051-3.214h.637l3.445 2.505a.84.84 0 0 0 .495.161c.778 0 1.14-.964.554-1.476L6.429 3.964V3.54l3.255-2.368a1 1 0 0 0 .412-.808v-1.578L5.044 2z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 2.667V4.8h3.667v2.533c0 .369.298.667.666.667h.762a.667.667 0 0 0 .667-.667V4.8h3.524a.667.667 0 0 0 .666-.667v-.8a.667.667 0 0 0-.666-.666H5.762V0H3.667v2.667z"
        clipRule="evenodd"
      />
      <path
        fill="#FF2E3B"
        fillRule="evenodd"
        d="M0 3.2h4.19V0h1.048v3.2h4.19v1.067h-4.19v3.2H4.19v-3.2H0z"
        clipRule="evenodd"
      />
      <path
        fill="#CA1931"
        fillRule="evenodd"
        d="m15.715 13.867-.741.22.217-.754-.217-.754.74.22.741-.22-.217.754.217.755zM15.715 3.733l-.741.221.217-.754-.217-.754.74.22.741-.22-.217.754.217.754zM18.857 6.933l-.74.221.216-.754-.217-.754.741.22.741-.22-.217.754.217.754zM12.571 8l-.74.22.216-.753-.217-.755.741.221.74-.22-.216.754.217.754z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagNZ;
